export default __webpack_public_path__ + "static/media/phone-off.1aab28bd.svg";